export const DTYPES = [
  { v: "percent", label: "Sconto %" },
  { v: "fixed", label: "Importo € fisso" },
  { v: "price", label: "Prezzo speciale" },
  { v: "bogo", label: "2x1 / Omaggio" },
];

export const normType = (t) => (t === "amount" ? "fixed" : (["percent", "fixed", "price", "bogo"].includes(t) ? t : "percent"));

export const emptyCoupon = () => ({ id: "", title: "", discount_type: "percent", discount_value: 10, description: "", images: [], min_spend: 0, has_expiry: true, expiry_days: 30 });

export const couponBadge = (t) => {
  const dt = normType(t.discount_type);
  const v = Number(t.discount_value || 0);
  if (dt === "percent") return `-${Math.round(v)}%`;
  if (dt === "fixed") return `-${Number.isInteger(v) ? v : v.toFixed(2)}€`;
  if (dt === "price") return `${Number.isInteger(v) ? v : v.toFixed(2)}€`;
  return "2x1";
};
